module.exports = __webpack_public_path__ + "static/media/askLogo.a648aadd.png";